module.exports = __webpack_public_path__ + "media/bootstrap-icons/x-bf336e02.svg";